import { useEffect, useMemo, useState } from "react";
import styles from "../../../styles/alumnievents.module.css";
import placeholder from '../../../images/alumnievent.png';
import { requesturl } from '../../../shared/utils/requesturl';

const ALUMNI_EVENTS_API = `${requesturl}alumnievents.php`;
const DEFAULT_EVENTS = [
    { id: 1, title: 'Science Week', start: '2025-12-08', end: '2025-12-12', color: '#f97316' },
    { id: 2, title: 'Winter Break', start: '2025-12-24', end: '2026-01-04', color: '#10b981' },
    { id: 4, title: 'Math Olympiad', start: '2025-12-10T14:30:00', end: '2025-12-10T16:00:00', color: '#6366f1' },
];

function formatEventDate(dateValue) {
    if (!dateValue) {
        return 'Date to be announced';
    }

    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) {
        return 'Date to be announced';
    }

    return date.toLocaleDateString(undefined, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });
}

function isDateOnlyValue(dateValue) {
    return typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue);
}

function getEventEndDate(event) {
    const endValue = event.end || event.start;
    const endDate = new Date(endValue);

    if (Number.isNaN(endDate.getTime())) {
        return null;
    }

    if (isDateOnlyValue(endValue)) {
        endDate.setHours(23, 59, 59, 999);
    }

    return Number.isNaN(endDate.getTime()) ? null : endDate;
}

const Events = () => {
    const [events, setEvents] = useState(DEFAULT_EVENTS);

    useEffect(() => {
        let cancelled = false;

        fetch(ALUMNI_EVENTS_API)
            .then((response) => response.json())
            .then((data) => {
                if (!cancelled && Array.isArray(data) && data.length > 0) {
                    setEvents(data);
                }
            })
            .catch(() => {
                // Keep fallback events if request fails.
            });

        return () => {
            cancelled = true;
        };
    }, []);

    const upcomingEvent = useMemo(() => {
        const now = new Date();

        const eligibleEvents = events
            .filter((event) => {
                const endDate = getEventEndDate(event);
                return endDate && endDate >= now;
            })
            .sort((a, b) => new Date(a.start) - new Date(b.start));

        return eligibleEvents[0] || null;
    }, [events]);

    const handleScrollToCalendar = () => {
        const calendarSection = document.getElementById('igsosa-calendar-section');
        if (calendarSection) {
            calendarSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const eventTitle = upcomingEvent ? upcomingEvent.title : 'No Upcoming Event';
    const eventDate = upcomingEvent ? formatEventDate(upcomingEvent.start) : 'No scheduled date yet';
    const eventDescription = upcomingEvent
        ? `${upcomingEvent.title} is the next closest event on the calendar. It will remain highlighted here until the event has finished.`
        : 'There is no upcoming alumni event scheduled right now. Please check the calendar section for future updates.';

    return (
        <div className={styles.eventswrapper}>
            <div className={styles.event}>
                <h2 className={styles.bannertext}>Upcoming Event</h2>
                <div className={styles.eventbanner}>
                    <img src={placeholder} alt="Upcoming event banner" className={styles.eventimg} />
                    <p className={styles.eventdate}>Date: {eventDate}</p>
                </div>
                <div className={styles.eventdetails}>
                    <h3 className={styles.eventtitle}>{eventTitle}</h3>

                    <p>{eventDescription}</p>

                    <button type="button" className={styles.btn} onClick={handleScrollToCalendar}>
                        View Calendar

                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-calendar-date" viewBox="0 0 16 16">
                            <path d="M6.445 11.688V6.354h-.633A13 13 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23" />
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Events;
